/*
 * @Author: chen hong
 * @Descripttion:
 * @Date: 2020-03-31 18:08:58
 */

const baseUrl = process.env.VUE_APP_BASE_API
export default baseUrl;
